import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  DocketSettingsRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { DocketSettingsScreen } from "../DocketSettingsScreen/DocketSettingsScreen";
import { EditDocketTemplateRootScreen } from "../EditDocketTemplateRootScreen/EditDocketTemplateRootScreen";
import { CreateDocketTemplateRootScreen } from "../CreateDocketTemplateRootScreen/CreateDocketTemplateRootScreen";

const Stack = createStackHeaderNavigator<DocketSettingsRootParamList>();

export interface DocketSettingsRootScreenProps
  extends StackScreenProps<SettingsRootParamList, "DocketSettingsRootScreen"> {}

export const DocketSettingsRootScreen = ({}: DocketSettingsRootScreenProps) => {
  return (
    <Stack.Navigator
      screenOptions={{
        animationEnabled: true,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Group
        screenOptions={{
          title: "",
          headerLeft: () => <ModalCloseButton type="Back" />,
        }}
      >
        <Stack.Screen
          name="DocketSettingsScreen"
          component={DocketSettingsScreen}
        />
      </Stack.Group>
      <Stack.Group
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen
          name="EditDocketTemplateRootScreen"
          component={EditDocketTemplateRootScreen}
        />
        <Stack.Screen
          name="CreateDocketTemplateRootScreen"
          component={CreateDocketTemplateRootScreen}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
